__webpack_require__.p = "/vue-2_shop-technozavrrr/";